import { AppLogo } from '@/components/common/AppLogo';
import { formatDisplayDate } from '@/utils/date';
import { formatTaka } from '@/utils/number';
import { PCMP_PENDING_STAGE_LABELS } from '../../constants/pcmpReports.constants';
import type { PcmpPendingReport, PcmpPendingStage } from '../../types/pcmpReports.types';
import { PcmpPendingReportTable } from './PcmpPendingReportTable';

interface PcmpPendingReportSheetProps {
  report: PcmpPendingReport;
  stage: PcmpPendingStage | undefined;
  periodLabel: string;
}

/** The Pending report as printed: heading, what it covers, then the table. */
export function PcmpPendingReportSheet({
  report,
  stage,
  periodLabel,
}: PcmpPendingReportSheetProps) {
  const { cards } = report;

  return (
    <div className="flex flex-col gap-2 text-neutral-900">
      <div className="flex items-center justify-between gap-4">
        <AppLogo className="size-9" />
        <div className="text-right">
          <h1 className="text-base font-bold">Division and Region wise Pending Report</h1>
          <p className="text-xs text-neutral-600">
            {report.projectLabel} · {periodLabel}
            {stage ? ` · ${PCMP_PENDING_STAGE_LABELS[stage]}` : ''}
          </p>
          <p className="text-xs text-neutral-600">
            As of {formatDisplayDate(report.reportDate)} · Total proposed{' '}
            {formatTaka(report.totalAmount)}
          </p>
        </div>
      </div>
      <p className="text-xs">
        Submitted {cards.submitted} · Pending {cards.pending} · Verified {cards.verified} ·
        Disbursed {cards.disbursed} · Awaiting publish {cards.awaitingPublish}
      </p>
      <PcmpPendingReportTable report={report} />
    </div>
  );
}
